import { z, ZodType } from "zod";

export function normalize<T>(zod: ZodType<T>, obj: T, fallbackValue?: T): z.infer<ZodType<T>> {
  try {
    return zod.parse(obj);
  } catch (e) {
    console.error("Failed to validate object: ", {
      obj
    });
    console.error(e);
    if (fallbackValue) {
      return fallbackValue;
    } else {
      throw new Error("Validation error");
    }
  }
}